import React from 'react';
import { View, PressableProps, Pressable } from 'react-native';

type MB_PressableProps = PressableProps & React.RefAttributes<View> & {
  /**
   * Callback when hovering in.
   */
  onHoverIn?: (event: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => void,
  
  /**
   * Callback when hovering out.
   */
  onHoverOut?: (event: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => void,
  
  /**
   * Callback when right clicking on web.
   */
  onContextMenu?: (event: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => void,
}

interface MB_PressableStateCallbackType {
  hovered?: boolean // Exist only on web
  focused?: boolean // Exist only on web
  pressed: boolean
}

const MB_Pressable = (props: MB_PressableProps) => {
  return (
    <Pressable {...props} />
  );
};

export { MB_Pressable };
export type { MB_PressableStateCallbackType, MB_PressableProps };
